import DetailsTitle from "components/common/detailsPage/DetailsTitle";
import DetailsShimmer from "components/common/shimmer/DetailsShimmer";
import { CustomerStatusBadge } from "components/common/StatusBadge";
import { usePermission } from "hooks/usePermission";
import { useQueryParam } from "hooks/useQueryParam";
import React, { useEffect } from "react";
import { Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { formatUTCDate } from "utils/utils";
import InfoItem from "components/common/detailsPage/InfoItem";
import NoPermission from "components/common/NoPermission";
import { getCouponDetails } from "store/slices/couponSlice";
import { Link } from "react-router-dom";
import { SquareArrowUpRightIcon } from "lucide-react";

const CouponDetails = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const id = useQueryParam("coupon_id");

  const { canAction } = usePermission();
  const { canView } = canAction("coupon");

  const { loading, itemDetails } = useSelector((state) => state.Coupons);

  const {
    _id,
    couponCode,
    visibility,
    discountType,
    discountAmount,
    startsAt,
    endsAt,
    status,
    createdAt,
    totalRedemptions,
  } = itemDetails || {};


  useEffect(() => {
    if (id && canView) {
      dispatch(getCouponDetails(id));
    }
  }, [id, canView,dispatch]);

  const infoFields = [
    {
      label: t("Coupon Code"),
      value: couponCode,
      col: { lg: 3, md: 3 },
    },
    {
      label: t("Visibility"),
      value: visibility,
      col: { lg: 3, md: 3 },
    },
    {
      label: t("Discount Type"),
      value: discountType ?? "-",
      col: { lg: 3, md: 3 },
    },
    {
      label: t("Discount Amount"),
      value: discountAmount,
      col: { lg: 3, md: 3 },
    },
    { isSpacer: true },
    {
      label: t("Created Date"),
      value: createdAt ? formatUTCDate(createdAt) : "-",
      col: { lg: 3, md: 3 },
    },
    {
      label: t("Start Date"),
      value: startsAt ? formatUTCDate(startsAt) : "-",
      col: { lg: 3, md: 3 },
    },
    {
      label: t("End Date"),
      value: endsAt ? formatUTCDate(endsAt) : "-",
      col: { lg: 3, md: 3 },
    },
    {
      label: t("Status"),
      render: <CustomerStatusBadge status={status} t={t} />,
      col: { lg: 3, md: 3 },
    },
    { isSpacer: true },
    {
      label: t("Total Redemption"),
      value: totalRedemptions ?? "-",
      col: { lg: 3, md: 3 },
    },
    {
      label: t("Usage History"),
      render: (
        <Link to={`/coupons/applied-coupons?coupon_id=${_id}`}>
          <div className="d-flex">
            <span>{t("View Usage History")}</span>
              <SquareArrowUpRightIcon width={24} height={24} color="#53c3eb" />
            
          </div>
        </Link>
      ),
      col: { lg: 3, md: 3 },
    },
  ];
  const shimmerLayout = [
    {
      col: 12,
      blocks: [
        { rows: 1, cols: 6 },
        { rows: 1, cols: 5 },
      ],
    },
    {
      col: 12,
      blocks: [{ rows: 1, cols: 3 }],
    },
    {
      col: 12,
      type: "details_page_tab",
      blocks: [{ rows: 1, cols: 1 }],
    },
  ];

  if (!canView) return <NoPermission />;

  if (loading) {
    return (
      <div className="page-content">
        <DetailsTitle title={t("Coupon Details")} />
        <DetailsShimmer layout={shimmerLayout} />
      </div>
    );
  }

  return (
    <div className="page-content common_details_page customer_details">
      <DetailsTitle title={t("Coupon Details")} />
      <div className="common_card">
        <h2 className="title_20 mb-4">{t("General Details")}</h2>
        <Row>
          {infoFields.map((item, index) => {
            if (item.isSpacer) {
              return <div key={index} className="mt-4 w-100" />;
            }

            return (
              <InfoItem
                key={index}
                label={item.label}
                value={item.value}
                col={item.col}
              >
                {item.render}
              </InfoItem>
            );
          })}
        </Row>
      </div>
      <div className="common_card mt_20 p-0">
        {/* <AppliedCouponsHistory userId={id} isFromUserDetails={true} /> */}
      </div>
    </div>
  );
};

export default CouponDetails;
